import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";

interface RUMGraphHeaderProps {
  title: string;
  supportLink?: string;
}

export const RUMGraphHeader = ({title, supportLink}: RUMGraphHeaderProps) => (
  <div className="d-flex align-items-baseline">
    <h5 className="">{title}</h5>
    {supportLink && <FormSubtext supportLink={supportLink} className="ms-1" />}
  </div>
);
